import React from 'react';

import { areLastStatesEnabled } from '../../constants/AppConfig';

import ErrorBoundary from '../../components/ErrorBoundary';

import {
    useIsDataGridPaneVisible,
    useIsGridFullScreenOrAnalytics,
} from './selectors/index.hooks';
import useDiscoveryLayout from './hooks/useDiscoveryLayout';
import { TStyling } from './components/_utils/types';
import DiscoveryMap from './components/DiscoveryMap';
import { Hidden } from '@material-ui/core';
import SearchPane from './components/SearchPane';
import GridTogglers from './components/GridTogglers';
import Bookmarks from './components/Bookmarks';

interface IOwnProps {
    isMobile: boolean;
}

const getMobileMapPaneComponentsStyling = (): TStyling =>
    [
        {
            predicate: () => true,
            style: {
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 56,
                left: 0,
            },
        },
    ].find(({ predicate }) => predicate());

const MapPane = ({ isMobile }: IOwnProps) => {
    const { layoutClassName } = useDiscoveryLayout();
    const isGridFullscreen = useIsGridFullScreenOrAnalytics();
    const isDataGridPaneVisible = useIsDataGridPaneVisible();

    const mobileMapPaneComponentsStyling = getMobileMapPaneComponentsStyling();
    return (
        <>
            {!isGridFullscreen && (
                <div
                    style={
                        isMobile
                            ? mobileMapPaneComponentsStyling?.style
                            : { height: '100%' }
                    }
                >
                    <ErrorBoundary>
                        <>
                            <DiscoveryMap layout={layoutClassName} />
                            <Hidden smDown>
                                {areLastStatesEnabled() && <SearchPane />}
                                <ErrorBoundary>
                                    <Bookmarks />
                                </ErrorBoundary>
                                {!isDataGridPaneVisible && <GridTogglers />}
                            </Hidden>
                        </>
                    </ErrorBoundary>
                </div>
            )}
        </>
    );
};

export default MapPane;
